<template>
    <SideBarModal title="Charity Gift" :show="show" @close="$emit('close')">
        <template v-slot:content>
            <div v-if="giftData">
                <h5 class="mb-3">Gift to</h5>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full">
                        <vs-input
                            v-model="giftData.charity_name"
                            class="w-full"
                            label="Charity Name"
                        />
                    </div>
                    <div class="vx-col w-full">
                        <vs-input
                            v-model="giftData.charity_number"
                            class="w-full"
                            label="Charity Number"
                        />
                    </div>
                    <vs-divider />
                </div>
                <h5 class="mb-3">Description</h5>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full mb-3">
                        <vs-input
                            v-model="giftData.amount"
                            type="number"
                            label="Amount"
                            class="w-full"
                        />
                    </div>
                    <div class="vx-col flex w-full mb-3">
                        <label>RPI Linked</label>
                        <vs-switch v-model="giftData.rpi" class="ml-auto" />
                    </div>
                    <div class="vx-col flex w-full mb-3">
                        <label>Before Partner</label>
                        <vs-switch
                            v-model="giftData.gift_before_partner"
                            class="ml-auto"
                        />
                    </div>
                    <div class="vx-col flex w-full">
                        <label>After Partner</label>
                        <vs-switch
                            v-model="giftData.gift_after_partner"
                            class="ml-auto"
                        />
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:buttons>
            <vs-button class="mr-6" @click="giftSave" :disabled="!validateForm"
                >Save</vs-button
            >
            <vs-button type="border" color="danger" @click="$emit('close')"
                >Cancel</vs-button
            >
        </template>
    </SideBarModal>
</template>

<script>
import { http } from '@/services'
import PersonSelect from '@/components/common/PersonSelect'
import GroupShareOptions from '@/components/common/GroupShareOptions'
import SideBarModal from '@/components/common/SideBarModal'

export default {
    name: 'CharityGiftModal',
    components: {
        SideBarModal,
    },
    props: ['gift', 'show', 'userId'],
    watch: {
        gift: {
            deep: true,
            immediate: true,
            handler(data) {
                if (data) this.giftData = { ...data }
                else this.clearForm()
            },
        },
    },
    data() {
        return {
            giftData: {
                id: null,
                user: null,
                charity_name: null,
                charity_number: null,
                amount: null,
                rpi: false,
                gift_before_partner: false,
                gift_after_partner: false,
            },
        }
    },
    computed: {
        validateForm() {
            if (
                this.giftData.charity_name &&
                this.giftData.charity_number &&
                this.giftData.amount
            )
                return true
            return false
        },
    },
    methods: {
        giftSave() {
            if (this.giftData && this.giftData.id) {
                http.patch('gift_charity', this.giftData)
                    .then((response) => {
                        this.$emit('newDataGifts', response.data)
                        this.$emit('close')
                        this.$emit('changed')
                        this.$vs.notify({
                            text: 'Saved',
                            color: 'success',
                        })
                        this.clearForm()
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            } else if (this.userId) {
                this.giftData.user = this.userId
                http.post('gift_charity', this.giftData)
                    .then((response) => {
                        this.$emit('close')
                        this.$emit('newDataGifts', response.data)
                        this.$vs.notify({
                            text: 'Saved',
                            color: 'success',
                        })
                        this.clearForm()
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        setPerson(value) {
            if (value) this.giftData.beneficiary = value.id
            else this.giftData.beneficiary = null
        },
        setShare(value) {
            if (value) this.giftData.beneficiary_group_share = value.value
            else this.giftData.beneficiary_group_share = null
        },
        clearForm() {
            this.giftData.id = null
            this.giftData.user = null
            this.giftData.charity_name = null
            this.giftData.charity_number = null
            this.giftData.amount = null
            this.giftData.rpi = false
            this.giftData.gift_before_partner = false
            this.giftData.gift_after_partner = false
        },
    },
}
</script>
